import { Dimensions } from 'react-native';
import { Platform } from 'react-native';

export const PopoverCloseButton = {
  baseStyle: () => ({
    position: 'absolute',
    right: 3,
    top: 3,
    zIndex: 1,
    p: '2',
    bg: 'transparent',
    borderRadius: 'sm',
    _web: {
      outlineWidth: 0,
      cursor: 'pointer',
    },
    _icon: {
      size: '4',
    },
    _light: {
      _icon: {
        color: 'muted.500',
      },
      _hover: {
        bg: 'muted.200',
      },
      _pressed: {
        bg: 'muted.300',
      },
    },
    _dark: {
      _icon: {
        color: 'muted.400',
      },
      _hover: {
        bg: 'muted.700',
      },
      _pressed: {
        bg: 'muted.600',
      },
    },
  }),
};

export const PopoverBody = {
  baseStyle: () => ({
    p: 0,
    borderTopWidth: 0,
    shadow: 'none',
    flex: 1,
    _text: {
      color: 'default',
      fontSize: 'md',
      lineHeight: 'md',
    },
    _light: {
      bgColor: 'white',
    },
    _dark: {
      bgColor: 'muted.800',
    },
  }),
};

export const PopoverContent = {
  baseStyle: () => ({
    shadow: 1,
    p: 4,
    mx: 4,
    _light: {
      bgColor: 'white',
    },
    borderWidth: 0,
    borderRadius: 4,
    overflow: 'visible',
    w: Platform.select({
      web: 350,
      native: Dimensions.get('window').width - 32,
    }),
    _icon: {
      w: 5,
      h: '25px',
      justifyContent: 'center',
      mr: 2,
    },
  }),
};

export const PopoverHeader = {
  baseStyle: () => ({
    _web: {
      accessibilityRole: 'header',
    },
    p: 0,
    borderBottomWidth: 0,
    _text: {
      fontSize: 'md',
      fontWeight: 'semibold',
      lineHeight: 'md',
      color: 'default',
    },
    _light: {
      bgColor: 'white',
      borderColor: 'white',
    },
    _dark: {
      bg: 'muted.800',
      borderColor: 'muted.700',
      _text: {
        color: 'text.50',
      },
    },
  }),
};

export const PopoverArrow = {
  baseStyle: () => ({
    _android: {
      bgColor: 'transparent',
      borderColor: 'transparent',
    },
    _light: {
      bgColor: 'white',
      borderColor: 'white',
    },
    _dark: {
      bg: 'muted.800',
    },
  }),
};

export const PopoverFooter = {
  baseStyle: () => {
    return {
      p: 0,
      mt: 3,
      borderTopWidth: 0,
      shadow: 'none',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      _light: {
        bg: 'white',
      },
      _dark: {
        bg: 'muted.800',
      },
    };
  },
};
